import {
  GenerateNavItemLabelLinesRequestDto,
  GenerateNavItemLabelLinesResponseDtoResponse,
} from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import {
  QueryKeyWithRole,
  unwrapQueryKeyWithRole,
} from '../../utils/prependRoleId';
import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export type NavItemLabelLinesQueryKey = readonly [
  string,
  string,
  string,
  string,
  GenerateNavItemLabelLinesRequestDto,
];

export const fetchNavItemLabelLines: QueryFunction<
  GenerateNavItemLabelLinesResponseDtoResponse,
  QueryKeyWithRole<NavItemLabelLinesQueryKey>
> = async ({ queryKey }) => {
  const params = unwrapQueryKeyWithRole(queryKey).params;
  const pageId = params[0];
  const requestBody = params[4];
  const response = await portalGatewayClient.page.generateNavItemLabelLines(
    pageId,
    requestBody
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(
        response.error,
        'Error generating detail page nav item label lines.'
      ),
      response
    );
  }

  return response.data;
};
